<div class="py-6 text-sm text-gray-900">
  <ng-content></ng-content>
</div>
